<template>
  <el-button
    class="cameraMosaicToggle"
    :class="{ 'cameraMosaicToggle--active': active }"
    icon="el-icon-s-grid"
    type="text"
    @click="toggle"
  >{{ $t('vehicleDetail.mosaic') }}</el-button>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CameraMosaic',
  props: {
    device: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters(['mosaicDeviceId']),
    active() {
      return this.mosaicDeviceId === this.device.id
    }
  },
  methods: {
    toggle() {
      this.$store.dispatch('transient/toggleMosaic', this.device.id)
    }
  }
}
</script>

<style lang="scss">
  @import '../../styles/element-variables.scss';

  .cameraMosaicToggle--active {
    color: $--color-primary;
  }
</style>
